<template>
  <footer class="faq-footer">
    <BlTextAv variation="body-16" data-testid="faq-footer-copyright-text" class="text-white">
      ©{{ getCurrentYear }} Copyright PT Bukalapak.com
    </BlTextAv>
    <div class="mt-24">
      <a href="https://www.linkedin.com/company/pt-bukalapak-com" rel="nofollow">
        <img
          :src="$publicUrl('images/kartu-prakerja/ico_linkedin.webp')"
          alt="ico_linkedin"
          loading="lazy"
          width="24"
          height="24"
          class="mh-32"
        />
      </a>
      <a href="https://twitter.com/bukalapak" rel="nofollow">
        <img
          :src="$publicUrl('images/kartu-prakerja/ico_twitter.svg')"
          alt="ico_twitter"
          loading="lazy"
          width="24"
          height="24"
          class="mh-32"
        />
      </a>
      <a href="https://www.instagram.com/bukalapak" rel="nofollow">
        <img
          :src="$publicUrl('images/kartu-prakerja/ico_instagram.webp')"
          alt="ico_instagram"
          loading="lazy"
          width="24"
          height="24"
          class="mh-32"
        />
      </a>
    </div>

    <div class="mt-24">
      <a href="https://play.google.com/store/apps/details?id=com.bukalapak.android" rel="nofollow">
        <img
          :src="$publicUrl('images/kartu-prakerja/image_playstore.webp')"
          alt="image_playstore"
          loading="lazy"
          width="105"
          height="32"
          class="mr-4"
        />
      </a>
      <a href="https://itunes.apple.com/app/id1003169137" rel="nofollow">
        <img :src="$publicUrl('images/kartu-prakerja/image_appstore.webp')" alt="image_appstore" loading="lazy" width="105" height="32" />
      </a>
    </div>
  </footer>
</template>

<script>
import {BlTextAv} from '@bukalapak/bazaar-mweb-latest';

export default {
  name: 'FaqFooter',
  components: {
    BlTextAv,
  },
  computed: {
    getCurrentYear() {
      const date = new Date();
      return date.toLocaleString('ID', {year: 'numeric'});
    },
  },
};
</script>

<style lang="scss" scoped>
.faq-footer {
  background-color: #141414;
  padding: 16px;
  display: flex;
  flex-direction: column;
  text-align: center;
}
</style>
